import { createFileRoute } from '@tanstack/react-router';
import { ChecklistEditorPage } from '@/features/checklists/pages/checklist-editor-page';

export const Route = createFileRoute('/_app/checklists/new')({ component: ChecklistEditorPage });
